export const getMaterialTypeLabel = (type: string): string => {
	const normalized = type.trim().toLowerCase();
	if (normalized === 'natural') return 'Natural-Dominant';
	if (normalized === 'hybrid') return 'Balanced / Hybrid';
	if (normalized === 'synthetic') return 'Standard Commercial Palettes';
	return type;
};

